/**
 * Module dependencies.
 */

import { useRequestProvider } from 'app/components/providers/request-provider/request-provider';
import { resolveAppUrl } from 'app/core/utils/url-resolver';
import { AxiosInstance } from 'axios';
import { useQuery } from '@tanstack/react-query';
import { PharmacyIntegration } from 'app/types/pharmacy-consents';

/**
 * Get pharmacies integrations.
 */

function getPharmaciesIntegrations(client: AxiosInstance, pharmacyId: string): Promise<PharmacyIntegration[]> {
  return client
    .get(resolveAppUrl('pharmaciesIntegrations', { interpolations: { pharmacyId } }))
    .then(({ data }) => data?.data);
}

/**
 * Export `useGetPharmacyIntegrations`.
 */

export function useGetPharmacyIntegrations(pharmacyId: string | null | undefined) {
  const client = useRequestProvider();

  return useQuery(['pharmacyIntegrations'], {
    queryFn: async () => {
      if (!pharmacyId) {
        return [];
      }

      return await getPharmaciesIntegrations(client, pharmacyId);
    }
  });
}
